import React from "react";

import PropTypes from "prop-types";
import {
  IoArrowBack,
  IoArrowForward,
  IoAddCircleOutline,
  IoRemoveCircleOutline
} from "react-icons/io5";

const Controls = ({ handleNext, handlePrev, zoomOut, zoomIn }) => (
  <React.Fragment>
    <div className="timeplanner-control-group">
      <button className="btn btn-blue" onClick={handlePrev}>
        <IoArrowBack size={18} />
      </button>
      <button className="btn btn-blue" onClick={handleNext}>
        <IoArrowForward size={18} />
      </button>
      <button className="btn btn-blue" onClick={zoomOut}>
        <IoRemoveCircleOutline size={18} />
      </button>
      <button className="btn btn-blue" onClick={zoomIn}>
        <IoAddCircleOutline size={18} />
      </button>
    </div>
  </React.Fragment>
);

Controls.propTypes = {
  zoomIn: PropTypes.func,
  zoomOut: PropTypes.func,
  handleNext: PropTypes.func,
  handlePrev: PropTypes.func
};

export default Controls;
